module.exports = __webpack_public_path__ + "media/images/location-6777abcb80d62d566e7fb16c1ee77b1b.svg";